import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {EndpointService} from './endpoint.service';
import {GetHistoryOrdersMinimalRequest, GetHistoryOrdersRequest} from '../requests/GetHistoryOrdersRequest';
import {GetHistoryOrdersResponse} from '../responses/GetHistoryOrdersResponse';
import {CategoriesRequest} from '../requests/CategoriesRequest';
import {GetAllFilteredCategoriesResponse} from '../responses/GetAllFilteredCategoriesResponse';

@Injectable({providedIn: 'root'})
export class BenefitHistoryService {
  constructor(private http: HttpClient) {
  }

  getAllOrdersHistory(userId: string, data: GetHistoryOrdersRequest) {
    return this.http.get<GetHistoryOrdersResponse>(EndpointService.getAllOrdersHistory(userId, data.paginationCriteria));
  }

  getAllOrdersHistoryMinimal(userId: string, data: GetHistoryOrdersMinimalRequest) {
    return this.http.get<GetHistoryOrdersResponse>(EndpointService.getAllOrdersHistoryMinimal(userId, data.minimalData, data.paginationCriteria));
  }

  getAllSubscriptionsHistory(userId: string, data: GetHistoryOrdersRequest) {
    return this.http.get<GetHistoryOrdersResponse>(EndpointService.getAllSubscriptionsHistory(userId, data.paginationCriteria));
  }

  getAllAutoOrdersHistory(userId: string, data: GetHistoryOrdersRequest) {
    return this.http.get<GetHistoryOrdersResponse>(EndpointService.getAllAutoOrdersHistory(userId, data.paginationCriteria));
  }

  getMyExpenseReports(userId: string, paginationStart: number, paginationLimit: number) {
    let params = new HttpParams()
      .set('PaginationCriteria.Start', paginationStart.toString())
      .set('PaginationCriteria.Limit', paginationLimit.toString());

    return this.http.get<any>(EndpointService.getUserExpenseReports(userId), { params });
  }

  getMyExpenseReportFileUrl(userId: string, reportId: string, fileId: string) {
    return this.http.get<any>(EndpointService.getUserExpenseReportFile(userId, reportId, fileId));
  }
}
